import React from 'react';
import {Button, NavLink, UncontrolledAlert} from 'reactstrap';
import {UsersEndpoints} from "../../common/ProxyEndpoints";
import AppColors from '../../common/Colors';
import NavigationHelper from "../../common/NavigationHelper";
import AppVariables from '../../common/AppVariables';
import TTLProxy from "../../common/TTLAsyncProxy";
import Utils from "../../common/Utils";
import MDProgress from 'react-md-progress-bar';
import LogoHeader from "../../components/LogoHeader/LogoHeader";
import {Form, Formik} from "formik";
import _ from 'lodash';
import * as Yup from 'yup';
import DocumentTitle from 'react-document-title';
import PlatformRender from "../../components/PlatformRender/PlatformRender";
import {DevicePlatforms} from "../../common/Constants";
import CodeInputView from "../../components/CodeInputView/CodeInputView";

export const ActivationFormSchema = Yup.object().shape({
   activation_code: Yup.string().required("Please enter a valid activation code")
       .min(_.min(AppVariables.ValidTokenLengths))
       .test(value => value && !value.includes(' '))
       .label("Activation")
});


class ActivateAccount extends React.Component {

    constructor(props){
        super(props);

        //  set state
        this.state = {
            isBusy : false,
            errorMessage: null,
            warningMessage: null,
            infoMessage: null,
            activateInfo : ActivateAccount.GetActivationInfo(),
            validLength: false
        };

        //
        this.proxy = TTLProxy.getInstance();
    }

     static GetActivationInfo(){

        let info = window.sessionStorage.getItem('activation_info');
        if(info){
            return JSON.parse(info);
        }

        return null;
    }

    componentWillMount(){

        //  check whether activation data is present
        if(!this.state.activateInfo){
            return this.props.history.push('/login');
        }

    }

    /**
     * Causes activation token to be resent
     * @param evt
     * @returns {Promise.<TResult>}
     */
    onResendToken(evt){

        evt.preventDefault();

        const proxy = this.proxy;
        const me = this;

        //
        this.setState({
            isBusy: true,
            warningMessage: null,
            errorMessage: null,
            infoMessage: null
        });

        //
        return proxy.processRequest( UsersEndpoints.beginActivation( AppVariables.DefaultDispatchMode ,this.state.activateInfo.identity) ).then((response) =>{

            if(response.ok){

                this.setState({
                    infoMessage: "Activation code sent successfully!"
                });

            }

            this.setState({
                isBusy: false
            });

        }).catch((err) =>{

            me.setState({
                isBusy: false,
                warningMessage: Utils.getResponseError(err)
            });

        });


    }

    renderBottomFrame(){

        return (<div style={{'marginTop' : '10px'}}>
                    <div className="text-center">
                        <NavLink href="#" onClick={Utils.navigateLink.bind(this,'/login')} style={{ padding: '0' }}> <i className="icon-arrow-left"></i> <b>Back to Login</b></NavLink>
                    </div>
               </div>);
    }

    onActivate({ activation_code }){

        //
        const me = this;
        const proxy = this.proxy;

        //  legacy validation library support
        if(this._activateForm && this._activateForm.hasOwnProperty('validateAll')){

            if(Object.keys(this._activateForm.validateAll()).length > 0) {
                return;
            }

        }


        this.setState({
            isBusy: true,
            warningMessage: null,
            infoMessage: null,
        });

        //  send account activation request
        return proxy.processRequest(UsersEndpoints.activateAccount(activation_code,this.state.activateInfo.identity)).then((response) =>{


            //  account now activated
            if(response && response.ok){

                //  handle activation
                NavigationHelper.navigate('/login',{
                    tip: 'Account activated successfully. To begin, enter your credentials'
                });

            }
            else {

                //
                me.setState({
                    isBusy: false,
                    errorMessage: "Something went wrong. Please try again"
                });

            }

        }).catch((err) => {

            this.setState({
                isBusy: false,
                errorMessage: Utils.getResponseError(err)
            });

        });

    }

    render(){

        const state = this.state;
        let errorSection = state.errorMessage != null ? <p className="error-label">{state.errorMessage}</p> : null;
        let content = <Formik initialValues={{ activation_code: '' }}
                                 validationSchema={ActivationFormSchema}
                                 onSubmit={async (values,{ setSubmitting}) => {
                                     await this.onActivate(values);
                                     setSubmitting(false);
                                 }}>
            {({  isValid }) => {

                return <Form className="card-block">

                    <div className="text-center">

                        <PlatformRender platform={DevicePlatforms.Desktop}>
                            <h1>Activate Account</h1>
                        </PlatformRender>

                        <PlatformRender platform={DevicePlatforms.Mobile}>
                            <h4>Activate Account</h4>
                        </PlatformRender>

                        <p>Hello there, seems your account isn't yet activated. To proceed, kindly enter the activation code you received during the registration process</p>
                        <hr/>
                        <p>Click <a href="#" className="btn-link" onClick={this.onResendToken.bind(this)}><b>here</b></a> to resend the activation code</p>

                    <div className="form-group mb-3">

                     <CodeInputView name="activation_code"/>

                    </div>
                    {errorSection && (
                        <div className="input-group">
                            {errorSection}
                        </div>)
                    }

                    {this.state.warningMessage && <UncontrolledAlert color="warning">{this.state.warningMessage}</UncontrolledAlert>}
                    {this.state.infoMessage && <UncontrolledAlert color="info">{this.state.infoMessage}</UncontrolledAlert>}

                    <div className="input-group">
                        {this.state.isBusy ? <MDProgress show={true} overlay={false} />  : null}
                        <Button block color="green" type="submit" disabled={ state.isBusy ||  !isValid}>Activate Account <i className="fa fa-check"></i></Button>
                    </div>

                    {this.renderBottomFrame()}

                    </div>

                </Form>
            }}
        </Formik>;


        return (<DocumentTitle title={"Activate Account"}>
                <React.Fragment>

                    <PlatformRender platform={DevicePlatforms.Desktop}>
                        <div className="app flex-row align-items-center" style={{backgroundColor: AppColors.PageBackgroundColor }} >
                            <div className="container">
                                <div className="row justify-content-center">
                                    <div className="col-md-8">
                                        <div className="card-group mb-0">
                                            <div className="card p-4 login-form animated fadeIn" >
                                                <LogoHeader />
                                                {content}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </PlatformRender>

                    <PlatformRender platform={DevicePlatforms.Mobile} onActivate={() => { window.document.body.style.backgroundColor = AppColors.PageWhiteBgColor }} onDeactivate={() => { window.document.body.style.backgroundColor = this._bodyColor }}>
                        <div style={{ width: '100%' }}>
                            <LogoHeader style={{padding: 17 , paddingBottom: 0}}/>
                            {content}
                        </div>
                    </PlatformRender>



                </React.Fragment>
            </DocumentTitle>);
    }

}

export default ActivateAccount;


// WEBPACK FOOTER //
// ./src/views/ActivateAccount/ActivateAccount.js